/* eslint-disable max-len */
export const findLocation = (state) => (id) => state.all.find((l) => l.id === id);
export const findLocationByUUID = (state) => (uuid) => state.all.find((l) => l.uuid === uuid);
export const getDefaultLocation = (state) => state.all[0];
export const getDeliveryMethod = (state) => (payload) => state.deliveryMethods.find((entry) => entry.id === payload);
export const getDeliveryMethodWaitingTime = (state) => (payload) => state.all[0].waitingTimes.find((entry) => entry.deliveryMethodId === payload);
